import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/content";
import { formatDate, formatViews } from "@/lib/content";
import CategoryBadge from "@/components/feature/CategoryBadge";
import NewsCard from "@/components/feature/NewsCard";

interface PopularSectionProps {
  items: NewsItem[];
}

export default function PopularSection({ items }: PopularSectionProps) {
  if (items.length === 0) return null;
  const [first, second, ...ranked] = items;

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
        <div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 flex items-center gap-2">
            <i className="ri-fire-line text-primary-500"></i>
            热门推荐
          </h2>
          <p className="mt-1 text-sm text-foreground-500">
            基于站内浏览量的热度排序（演示数据）
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-5">
        <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {[first, second].map((item) => (
            <NewsCard key={item.id} item={item} />
          ))}
        </div>

        <div className="lg:col-span-4 bg-accent-50 border border-accent-100 rounded-lg p-5 md:p-6">
          <h3 className="text-sm font-semibold text-accent-800 flex items-center gap-2 mb-5">
            <i className="ri-bar-chart-box-line"></i>
            热度榜单
          </h3>
          <div className="flex flex-col gap-4">
            {ranked.slice(0, 5).map((item, idx) => (
              <NewsCard key={item.id} item={item} variant="compact" index={idx} />
            ))}
          </div>

          <div className="mt-6 pt-5 border-t border-accent-200/70">
            <p className="text-xs text-foreground-500 mb-3">编辑推荐</p>
            {items[0] && (
              <Link
                to={`/detail/${items[0].id}`}
                className="group block cursor-pointer"
              >
                <div className="flex items-center gap-2 flex-wrap">
                  <CategoryBadge
                    categoryKey={items[0].categoryKey}
                    name={items[0].categoryName}
                  />
                  <span className="text-xs text-foreground-500">
                    {formatDate(items[0].publishDate)} · {formatViews(items[0].views)}
                  </span>
                </div>
                <h4 className="mt-2 text-sm font-medium text-foreground-900 group-hover:text-accent-700 transition-colors line-clamp-2">
                  {items[0].title}
                </h4>
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}